// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2dy-b","modalForm":"UpgradeEpcsModal_modalForm__1775l","modalFooter":"UpgradeEpcsModal_modalFooter__OZYI9"};